import axios from "axios"

const paramsSerializer = (params) => {
  const Qs = require("qs")
  return Qs.stringify(params, { encode: false })
}

export const getFile = (headers, path) => {
  return axios.get(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/files/${path}`,
    {
      headers,
      responseType: "arraybuffer"
    }
  )
}

export const findFiles = (headers, params) => {
  return axios.get(`${process.env.REACT_APP_MANAGEMENT_API_URL}/files`, {
    headers,
    params,
    paramsSerializer
  })
}